<template>
  <v-dialog :value="active" :lazy="true" persistent max-width="100%">
    <v-card>
      <v-form ref="editForm" @submit.prevent="update()">
        <v-toolbar card color="primary" dark>
          <v-spacer></v-spacer>
          <v-toolbar-title>{{$t('instructions.updateTitle')}}</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text v-if="currentModel == null" class="text-xs-center">
          <v-progress-circular :width="6" :size="60" indeterminate color="primary"></v-progress-circular>
        </v-card-text>
        <v-card-text v-else>
          <v-container fluid grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field
                  :label="$t('instructions.name')"
                  v-model="currentModel.name"
                  :rules="[v => !!v || $t('fields.required')]"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-btn
                  color="primary"
                  block
                  @click.native="$refs.addinstruction.click()"
                  :loading="$store.state.companies.loading"
                >{{$t('instructions.addInstruction')}}</v-btn>
                <input
                  ref="addinstruction"
                  type="file"
                  multiple
                  accept=".png, .jpeg, .jpg"
                  @change="addNewSlide($event)"
                  style="display:none"
                />
              </v-flex>
              <v-flex xs12>
                <draggable
                  v-model="instructionsList"
                  tag="v-layout"
                  class="row wrap queue-container"
                  v-bind="dragOptions"
                >
                  <v-flex
                    xs12
                    sm12
                    md6
                    xl4
                    v-for="(element, index)  in instructionsList"
                    :key="index"
                    class="px-0"
                  >
                    <v-card class="ma-3" elevation="20">
                      <v-toolbar>
                        <v-icon class="dragHandler">more_horiz</v-icon>

                        <v-spacer></v-spacer>
                        <v-btn-toggle multiple v-model="element.factory">
                          <v-btn value="factory">
                            <span>Usine</span>
                          </v-btn>
                          <v-btn value="non-factory">
                            <span>Autres</span>
                          </v-btn>
                        </v-btn-toggle>
                        <v-spacer></v-spacer>
                        <v-btn-toggle multiple v-model="element.dd">
                          <v-btn value="dd">DD</v-btn>
                          <v-btn value="non-dd">Autres</v-btn>
                        </v-btn-toggle>
                        <v-spacer></v-spacer>
                        <v-btn icon @click="$refs['updateinstruction'][index].click()" :loading="$store.state.companies.loading">
                          <v-icon>edit</v-icon>
                        </v-btn>
                        <input
                          ref="updateinstruction"
                          type="file"
                          accept=".png, .jpeg, .jpg"
                          @change="slideToUpdate = element.img; updateSlide($event)"
                          style="display:none"
                        />
                        <v-btn icon @click="slideToDelete = element._id; deleteDialog = true">
                          <v-icon>delete</v-icon>
                        </v-btn>
                      </v-toolbar>
                      <v-img contain :src="config.filesUrl + currentModel.instance + '/instructions/' + element.img"></v-img>
                    </v-card>
                  </v-flex>
                </draggable>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            :loading="$store.state.instructions.loading"
            submit
            flat
            type="submit"
          >{{$t('general.update')}}</v-btn>
          <v-btn
            color="secondary"
            :disabled="$store.state.instructions.loading"
            submit
            flat
            @click.native="$emit('closedialog')"
          >{{$t('general.close')}}</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
    <confirmation-dialog
      :active="deleteDialog"
      title="Confirmation ?"
      :message="$tc('instructions.deleteConfirmation', 1, {count: 1})"
      :loading="$store.state.instructions.loading"
      @confirmation="deleteSlide"
      @cancel="deleteDialog = false"
    ></confirmation-dialog>
  </v-dialog>
</template>

<script>

import ConfirmationDialog from "@/components/ConfirmationDialog";
import Config from "@/config";
import draggable from "vuedraggable";

export default {

  name: "UpdateSlide",

  props: { active: Boolean, id: {} },

  components: {
    draggable,
    ConfirmationDialog
  },

  data() {
    return {
      slideToDelete: "",
      slideToUpdate: "",
      deleteDialog: false,
      rules: {
        required: value => !!value || this.$t("fields.required")
      },
      currentModel: {}
    };
  },

  methods: {
    
    async init() {
      this.getModel();
      await this.$nextTick();
      this.$refs.editForm.reset();
    },

    async update() {
      if (this.$refs.editForm.validate()) {
        if (
          await this.$store.dispatch("instructions/update", {
            id: this.id,
            data: this.currentModel
          })
        ) {
          this.$emit("closedialog");
        }
      }
    },

    async getModel() {
      this.currentModel = null;
      let model = await this.$store.dispatch("instructions/getOne", this.id);
      this.currentModel = Object.assign({}, model);
    },

    async deleteSlide() {
      if (
        await this.$store.dispatch("instructions/deleteSlide", {
          id: this.currentModel._id.toString(),
          slide: this.slideToDelete
        })
      ) {
        let findIndex
        for (let index = 0; index < this.instructionsList.length; index++) {
          if (this.instructionsList[index]._id == this.slideToDelete) {
            findIndex = index
          }
        }
        this.instructionsList.splice(findIndex, 1)
        this.deleteDialog = false;
        this.slideToDelete = "";
      }
    },

    async addNewSlide(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return;
      }
      let formData = new FormData();
      for (let index = 0; index < files.length; index++) {
        formData.append("logo" + index, files[index]);
      }
      if (
        await this.$store.dispatch("instructions/addNewSlide", {
          id: this.currentModel._id.toString(),
          data: formData
        })
      ) {
        this.getModel();
      }
      this.$refs["addinstruction"].value = "";
    },

    async updateSlide(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return;
      }
      let formData = new FormData();
      formData.append("logo", files[0]);
      if (
        await this.$store.dispatch("instructions/updateSlide", {
          id: this.currentModel._id.toString(),
          data: formData,
          slide: this.slideToUpdate
        })
      ) {
        this.getModel();
      }
      this.$refs["updateinstruction"].value = "";
    }

  },

  computed: {

    config() {
      return Config;
    },

    instructionsList: {
      get() {
        return this.currentModel.list;
      },
      set(value) {
        this.currentModel.list = value;
      }
    },

    dragOptions() {
      return {
        animation: 200,
        handle: ".dragHandler"
      };
    }
  },

  watch: {
    active(val) {
      if (val) {
        this.init();
      }
    }
  }
};
</script>

<style>
.dragHandler {
  cursor: move;
}
</style>

